<template>
  <div class="courses">
    <!--fix issue #2183-->
    <swiper :options="swiperOptions">
      <swiper-slide v-for="(item, index) in courses"
        :key="index">
        <div class="courses-item">
          <img class="cover-img" :src="(item.cover ? item.cover.url : noImgUrl) | handleImageUrl('693', '390')">
          <div class="mask">
            <p class="logo">精选</p>
            <p class="title">{{ item.title }}</p>
            <P class="text">名师指导&nbsp;&nbsp;备考冲刺</P>
            <button @click="goPage(item)">点击观看</button>
          </div>
        </div>
      </swiper-slide>
      <!-- fix issue #1983 -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.min.css";

export default {
  props: {
    courses: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      noImgUrl: `${process.env.VUE_APP_CDN}img-cover.jpg`,
      // fix issue #2183
      swiperOptions: {
        loop: false,
        autoplay: {
          delay: 3000,
        },
        preventClicks: true,
        uniqueNavElements: false,
        pagination: {
          el: '.swiper-pagination',
        }
      },
    }
  },

  methods: {
    goPage(item) {
      if (item.status == 'NEW') {
        alert('资料还在准备中，计划更新时间为：' + item.plan_date);
        return;
      }
      let href = `/course/view.html?id=${item.id}`;
      if (!this.isWechat()) {
        href += '&isShowHead=true';
      }
      window.location.href = href;
    }
  }
}
</script>

<style scoped>
.courses {
  padding-bottom: 50px;
}

.mask {
  position: absolute;
  top: 0;
  width: 100%;
  height: 390px;
  padding: 128px 40px 30px;
  text-align: center;
  background: #282828;
  opacity: 0.75;
  color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
}

.courses-item {
  position: relative;
  margin: 0 auto;
  width: 693px;
  height: 390px;
  border-radius: 10px;
}

.cover-img {
  width: 693px;
  height: 390px;
}

button {
  margin-top: 30px;
  width: 131px;
  height: 38px;
  line-height: 38px;
  padding: 0;
  background: none;
  color: #fff;
  font-size: 20px;
  border: 1px solid #fff;
}

.title {
  margin-bottom: 28px;
  font-size: 36px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.text {
  font-size: 24px;
  letter-spacing: 4px;
}

.logo {
  position: absolute;
  top: 78px;
  right: 73px;
  width: 67px;
  height: 40px;
  line-height: 40px;
  font-size: 24px;
  background: url(https://cdn.laixue.com/h5/bg-jingxuan.png);
  background-size: 100% 100%;
}

.swiper-pagination>>>.swiper-pagination-bullet {
  margin: 0 8px;
  width: 12px;
  height: 12px;
  background: #f2f3f5;
  opacity: 0.3;
}

.swiper-pagination>>>.swiper-pagination-bullet-active {
  background: #fff;
  opacity: 1;
}

.swiper-pagination {
  text-align: right;
  left: -40px;
}

</style>
